import { type FormEvent, useState } from 'react'

import { supabase } from '../lib/supabase'
import { usernameToAuthEmail } from './username'

interface LoginPageProps {
  sessionError?: string | null
}

export function LoginPage({ sessionError }: LoginPageProps) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setSubmitting(true)
    setError(null)

    try {
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: usernameToAuthEmail(username),
        password,
      })
      if (signInError) setError('Não foi possível entrar. Confira seus dados e tente novamente.')
    } catch {
      setError('Falha de conexão. Tente novamente.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="login-page">
      <section className="login-brand" aria-labelledby="login-title">
        <a className="brand" href="https://www.hvm.com.br/" aria-label="HVM">
          hvm
        </a>
        <div>
          <p className="eyebrow">Controle de dados</p>
          <h1 id="login-title">Indicadores seguros. Decisões mais claras.</h1>
          <p>
            Acesso individual aos indicadores de atendimento da HVM, com
            histórico, governança e rastreabilidade.
          </p>
        </div>
      </section>

      <section className="login-panel" aria-label="Acesso ao sistema">
        <form className="login-form" onSubmit={handleSubmit}>
          <div>
            <p className="eyebrow">Área restrita</p>
            <h2>Entrar</h2>
            <p className="login-form__intro">
              Utilize o acesso fornecido pelo administrador do sistema.
            </p>
          </div>

          <label>
            Usuário
            <input
              autoCapitalize="none"
              autoComplete="username"
              onChange={(event) => setUsername(event.target.value)}
              required
              spellCheck={false}
              type="text"
              value={username}
            />
          </label>

          <label>
            Senha
            <input
              autoComplete="current-password"
              minLength={8}
              onChange={(event) => setPassword(event.target.value)}
              required
              type="password"
              value={password}
            />
          </label>

          {(error || sessionError) && (
            <p className="form-error" role="alert">
              {error ?? sessionError}
            </p>
          )}

          <button className="primary-button" disabled={submitting} type="submit">
            {submitting ? 'Validando…' : 'Entrar'}
          </button>
        </form>
      </section>
    </main>
  )
}
